import * as React from 'react';

import { Body1, Button, Image, UIHeading3 } from '@cian/ui-kit';
import reload from '../../assets/Reload.png';
import * as styles from './styles.css';

export interface IErrorContentProps {
  onReload: () => void;
}

export const ErrorContent = ({ onReload }: IErrorContentProps) => {
  return (
    <div className={styles['container']}>
      <Image src={reload} height={140} width={140} />
      <div className={styles['text-wrapper']}>
        <UIHeading3>Что-то пошло не так</UIHeading3>
        <Body1 textAlign="center">Проверьте интернет и попробуйте обновить</Body1>
      </div>
      <Button onClick={onReload} size="L">
        Обновить
      </Button>
    </div>
  );
};
